// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"197":"d913b4bb39cf6cc7","327":"d913b4bb39cf6cc7","820":"d913b4bb39cf6cc7","888":"adf1bdf9c5ca7d3f"}[chunkId] + ".css";
};